export default function Footer() {

    const currentYear = new Date().getFullYear();

    return (
        <div className="ui container" style={{marginTop: '2em'}}>
            <p>Copyright © 2014 - {currentYear} - Maesstad</p>
        </div>
    )
}